module.exports = __webpack_public_path__ + "img/mizhi-back-two@3x.61f0ce89.png";